module.exports = __webpack_public_path__ + "img/inspiration_01@2x.e6b32ef.jpg";